import { getPollResults, subscribePollResults } from '@/services/poll-results.service'
import { useSyncExternalStore } from 'react'

export function useFetchPollResults(pollEventId: string) {
  return useSyncExternalStore(
    (cb) => subscribePollResults(pollEventId, cb),
    () => getPollResults(pollEventId)
  )
}
